import React from "react";
import classnames from "classnames";
import defaultClassNames from "./TableBlockView.module.scss";
import { useUi } from "@jelly/lesson";
import { BlockBase, BlockOptions } from "@jelly/lesson/dist/@types";

import { Theme } from "@jelly/ui";

export interface TableCellOptions {
  disabled?: boolean;
  active?: boolean;
  theme?: Theme;
  colspan?: number;
  content: string;
}

/**
 * Parameters to setup TableBlock.
 */
export interface TableBlockOptions extends BlockOptions {
  rows: Array<{
    header?: boolean;
    cells: TableCellOptions[];
  }>;
}

export interface TableBlock extends BlockBase<TableBlockOptions> {
  type: "table";
}

export interface TableBlockViewProps extends TableBlockOptions {
  classNames?: Record<string, string>;
}

export const TableBlockView: React.FC<TableBlockViewProps> = (props) => {
  const { classNames = defaultClassNames, styles } = props;
  const { MathSvg } = useUi();

  function renderCell(cell: TableCellOptions, index: number): React.ReactNode {
    const { disabled, active, colspan = 1, theme = "default" } = cell;

    return (
      <td
        key={index}
        colSpan={colspan}
        className={classnames(classNames[theme], {
          [classNames.disabled]: disabled,
          [classNames.active]: active,
        })}
      >
        <MathSvg>{cell.content}</MathSvg>
      </td>
    );
  }

  return (
    <div className={classNames.tableBlock} style={styles}>
      <table>
        <tbody>
          {props.rows.map((row, index) => (
            <tr
              key={index}
              className={classnames(classNames.row, {
                [classNames.header]: row.header,
              })}
            >
              {row.cells.map(renderCell)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
